import controls from './controls/index'
import privateAccounts from './private/index'
import stores from './stores/index'

export default [
    ...controls,
    ...privateAccounts,
    ...stores,
]